import type { MessageActionVariables, SendMessageVariables } from "../types";
import { PROVIDER_MAP } from "../constants";
import { parseApiError } from "../error-handler";

export async function performMessageAction(
  variables: MessageActionVariables,
  token?: string
) {
  const { provider, messageId, connectionId, action, payload } = variables;
  const encodedMessageId = encodeURIComponent(messageId);
  const searchParams = new URLSearchParams({
    connectionId,
  });
  const url = `/api/connections/messages/${provider}/${encodedMessageId}/actions?${searchParams}`;

  let response: Response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ action, payload }),
    });
  } catch (error) {
    throw parseApiError(error);
  }

  if (!response.ok) {
    throw parseApiError(response);
  }

  return await response.json();
}

export async function sendMessage(variables: SendMessageVariables, token?: string) {
  const { provider, connectionId, to, cc, bcc, subject, body, attachments, trackOpens, inReplyTo, references } =
    variables;

  const providerKey = PROVIDER_MAP[provider] || provider;
  const url = `/api/connections/messages/${providerKey}/send?connectionId=${connectionId}`;

  const requestBody = { to, cc, bcc, subject, body, attachments, trackOpens, inReplyTo, references };

  let response: Response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(requestBody),
    });
  } catch (error) {
    throw parseApiError(error);
  }

  if (!response.ok) {
    throw parseApiError(response);
  }

  return await response.json();
}
